import { render, staticRenderFns } from "./articleTitle.vue?vue&type=template&id=c9c00f80"
import script from "./articleTitle.vue?vue&type=script&lang=js"
export * from "./articleTitle.vue?vue&type=script&lang=js"
import style0 from "./articleTitle.vue?vue&type=style&index=0&id=c9c00f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports